'use strict'

const hosts = {
  user: 'https://fnd.hanatour.com',
  userMobile: 'https://mfnd.hanatour.com',
  seller: 'https://fndseller.hanatour.com',
  hanatour: 'https://www.hanatour.com',
  hanatourAccount: 'https://accounts.hanatour.com',
  hanatourApi: 'https://api.hanatour.com',
  hanatourGw: 'https://gw.hanatour.com',
  hanatourImg: 'https://image.hanatour.com',
  fndStatic: 'https://static.hanatour.com',
  hatsApi: 'https://hats.hanatour.com',
  hanatourPay: 'https://pay.hanatour.com',
}

// 외부 API
const externalApi = {
  googleMap: {
    key: 'AIzaSyAKlC9AdN5hLaRGU83cbsaBQw8Y6EeDBC0',
  },
  googleAnalytic: {
    key: 'UA-23076506-21',
  },
  sentry: {
    dsn: 'https://9ce6d6a0aa68efe6f422baa1b01d65ce@fm.hanatour.com/5',
    url: 'https://fm.hanatour.com/',
  },
  netFunnel: {
    src: 'https://agent-lib.stclab.com/agents/client/javascript/netfunnel-javascript-agent.js',
    clientId: 'ittax-2863',
    projectKey: 'service_330',
    entrySegmentKey: 'segKey_6290',
    couponDownloadSegmentKey: 'segKey_8700',
    disabled: true,
  },
}

module.exports = {
  hosts,
  externalApi,
  deployEnv: 'prod',
  axiosTimeout: 10000,
  gtxSellerIds: ['MHJ-S230516002'], // 글로벌틱스 seller id (환경 내에서도 계정이 여러개일 수 있다)
  jtrSellerIds: ['MHJ-S220623001', 'MHJ-S220811001'], // JTR seller id
  grlSellerIds: ['MHJ-S231121002'], // 고릴라 seller id
  rakutenGoraSellerIds: ['MHJ-S250509001'],
  kkdaySellerIds: ['MHJ-S250523001'], // kkday seller id
}
